var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BAutocomplete',_vm._g(_vm._b({ref:"autocomplete",attrs:{"label":_vm.label,"no-data-text":"Раздел не найден","request":_vm.request}},'BAutocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }